import React from "react";
import PhoneField from "@xem/look/Renders/Field/Phone";

export default (function Phone(props){
	let { id: name, site, name: label, values, required, setFieldValue, onActions, tabIndex } = props || {}
	let country = site?.country;
	country = (country === '-')? 'VN': country;

	let value = values[name], options = { country };

	let sx = {
		padding: 0, '& .phone-country':{
			marginTop: 'auto', marginBottom: '7px'
		}
	}

	return <>
		<PhoneField
			sx={sx}
			{...{ className: 'Mui-textfield', site, inputProps: { inputMode: 'numeric', tabIndex: tabIndex++ } }}
			{...{ options, onActions, label, name, value, required }}
			onChange={setFieldValue}
		/>
	</>
})